<app-modal-base [title]="dialogTitle" [hasSubmit]="false" cancelType="CLOSE" [defaultCloseValue]="avatarUpdated">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <app-img-display [uid]="data.user.uid" [type]="'userAvatar'" [imageTs]="data.avatarTs" [hasBorder]="true"
      [reload]="data.avatarTs" size="120x120"></app-img-display>

    <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)" text="uploadFile.chooseFileImage"
      uploadText="uploadFile.uploadFileImage" [backendResponse]="backendResponseUploadedFile"
      [isLoading]="isLoadingUpload" [fileType]="'IMAGES'" [hasStrictSize]="false">
    </app-file-upload>
  </div>
</ng-template>
